module.exports = __webpack_public_path__ + "img/logo_chrome.0182088e.svg";